import { Button, Modal } from 'antd';
import Title from 'antd/es/typography/Title';
import styled from 'styled-components';

interface IProps {
  isVisible: boolean;
  isConfirming?: boolean;
  children: React.ReactNode | React.ReactNode[];
  title: React.ReactNode;
  onCancel(): void;
  onConfirm(): void;
  shouldDisableConfirm?: boolean;
  shouldDisableCancel?: boolean;
  okButtonText?: string;
  cancelButtonText?: string;
}

const ConfirmModal: React.FC<IProps> = ({
  isVisible,
  isConfirming,
  children,
  title,
  shouldDisableCancel,
  shouldDisableConfirm,
  onCancel,
  onConfirm,
  okButtonText,
  cancelButtonText,
}) => {
  return (
    <Modal
      open={isVisible}
      onCancel={onCancel}
      footer={null}
      destroyOnHidden={true}
      width={420}
    >
      <div>
        <Title style={{ marginTop: 0 }} level={5}>
          {title}
        </Title>
        {children}
        <ActionButtons>
          <Button onClick={onCancel} disabled={shouldDisableCancel}>
            {cancelButtonText || 'Cancel'}
          </Button>
          <Button
            type="primary"
            onClick={onConfirm}
            loading={isConfirming}
            disabled={shouldDisableConfirm}
          >
            {okButtonText || 'Confirm'}
          </Button>
        </ActionButtons>
      </div>
    </Modal>
  );
};

export const ActionButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: ${({ theme }) => theme.spacing.xl};

  button {
    min-width: 100px;
    height: ${({ theme }) => theme.spacing.xl};
    margin-left: ${({ theme }) => theme.spacing.sm};
    > span {
      font-size: 14px;
    }
  }
`;

export default ConfirmModal;
